<template>
  <div class="h5-program">
    <van-collapse accordion @change="getClassifyContent" v-model="activeName">
      <van-collapse-item icon="/static/images/etv-folder.png" v-for="(item,index) in classify" :key="index"
                         :title="item.name">
        <div class="templist">
          <div v-if="Programs.length" style="min-height: calc(100% - 44px)">
            <div class="h5-program-item" v-for="(item,index) in Programs" :key="item.id">
              <div class="h5-program-img">
                <img src="../assets/images/icon_app.png" alt="">
              </div>
              <div class="h5-program-text">
                <h4>{{ item.name }}</h4>
                <div class="h5-program-created">
                  {{$t('append_field.creation_time')}}：{{ item.createTime }}
                </div>
                <div class="h5-program-btns">
                  <router-link :to="'/h5editer/' + item.id"><span>{{$t('append_field.edit')}}</span></router-link>
                  <span @click="onDeleteProgram(item.id,index)">{{$t('append_field.delete')}}</span>
                  <span @click="onEmploy(item.id)">{{$t('append_field.preview')}}</span>
                  <span @click="gotoa(`/addTask`,{
                      grogramIds:item.id,
                      parentPage:'taskList',
                      progremData: [item]
                      })">{{$t('append_field.send')}}</span>
                </div>
              </div>
            </div>
          </div>
          <van-empty description="$t('append_field.no_data')" v-else/>
        </div>
      </van-collapse-item>
    </van-collapse>

  </div>
</template>


<script>
import qs from "qs"
import {Dialog, Toast} from 'vant';
import {mapActions} from "vuex";

export default {
  name: "production",
  data() {
    return {
      Programs: [],
      programId: "",
      pageNum: 1,
      classify: [],
      active: 0,
      activeName: 0,
    }
  },
  async mounted() {
    await this.getClassify()
    await this.getPrograms()
  },
  methods: {
    ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
    getPrograms() {
      this.$ajax.post("/etv/selectH5PageProgramMouldInfo.json", qs.stringify({
        pcId: this.classify[this.active].id,
        state: "0",
        name: "",
        pageNum: this.pageNum,
        pageSize: 99999,
      })).then(res => {
        if (res.data.code === 0) {
          this.Programs = res.data.data.pmList
          this.count = Math.ceil(res.data.data.totalNum / 10)
        }
      })
    },
    async getClassify() {
      await this.$ajax.post("/etv/selectH5ProgramCategoryAlls.json").then(res => {
        if (res.data.code === 0) {
          this.classify = res.data.data.pcList
          this.classify.map(res => {
            res.name = res.name.split("(")[0]
          })
        }
      })
    },
    getClassifyContent(id) {
      this.active = id
      this.getPrograms()
    },
    getpage(i) {
      this.pageNum = i
      this.getPrograms()
    },
    onDeleteProgram(id, index) {
      this.programId = id
      Dialog.confirm({
        title: this.$t('append_field.deleteP'),
        message: this.$t('append_field.con_P'),
      }).then(() => {
        this.deletePrograms(id, index)
      }).catch(() => {
      })
    },
    deletePrograms(id, index) {
      this.$ajax({
        url: '/etv/deleteProgramMouldById.json',
        method: 'post',
        data: qs.stringify({id: id})
      }).then(res => {
        let code = res.data.code
        let msg = res.data.msg
        if (code === 0) {
          Toast({type: 'success', message: this.$t('append_field.delete_success'), duration: 1000})
          this.Programs.splice(index, 1)
        } else {
          Toast(msg)
        }
      })
    },
    onEmploy(id) {
      this.$router.push({
        path: `/h5Preview/${id}`,
        query: {
          type: "jm"
        }
      })
    },
    gotoa(url, query) {
      this.$router.push({
        path: url,
        query,
      })
      if (url == '/addTask') {
        this.changeTopTitle(this.$t('append_field.addTask'))
        this.setParentPage('programs')
        this.changeTopIconStatus(true)
      }
    },
  }
}
</script>

<style scoped lang="scss">
.h5-program {
  overflow: auto;
  padding-top: 5px;
  height: 100%;

  .templist {
    & > div {
      .h5-program-item:nth-last-child(1){
        border: none;
      }
    }
  }

  .classify {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;

    span {
      padding: 5px 15px;
      margin: 5px;
      background: #cccccc;
      display: inline-block;
      border-radius: 3px;
    }

    .h5-active {
      background: #409EFF;
      color: white;
    }
  }

  .h5-program-item {
    margin-bottom: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #999999;
    overflow: hidden;

    .h5-program-img {
      height: 80px;
      width: 80px;
      float: left;
      background: #cccccc;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .h5-program-text {
      float: left;
      height: 80px;
      width: calc(100% - 80px);
      padding-left: 15px;
      box-sizing: border-box;

      .h5-program-created {
        margin-top: 5px;
      }

      .h5-program-btns {
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        width: 12em;
      }
    }
  }


}
</style>
